export default function setAnalyticsElements(elements) {
  if (typeof document === "undefined") return;

  // заранее делаем Map: class -> elementConfig
  const byClass = new Map();
  (elements || []).forEach((el) => {
    if (el?.css_selector && el.css_selector[0] === ".") {
      byClass.set(el.css_selector.slice(1), el);
    }
  });

  // кешируем скомпилированные обработчики, чтобы не делать new Function на каждый клик
  const compiled = new WeakMap();

  const run = (el) => {
    if (!el?.events?.length) return;

    let fn = compiled.get(el);
    if (!fn) {
      try {
        const body = el.events.map(({ code }) => code).join("\n");
        fn = new Function(body);
        compiled.set(el, fn);
      } catch (e) {
        return;
      }
    }

    try {
      fn();
    } catch (e) {}
  };

  const handler = (e) => {
    const path = (e.composedPath && e.composedPath()) || [];
    for (let i = 0; i < path.length; i++) {
      const node = path[i];
      if (!node || !node.classList) continue;

      for (const cls of node.classList) {
        const el = byClass.get(cls);
        if (el) {
          run(el);
          return;
        }
      }
    }
  };

  document.addEventListener("click", handler, { passive: true });

  // важно вернуть cleanup
  return () => document.removeEventListener("click", handler);
}
